import { useLayoutEffect } from 'react';

// Stops the page (the document) from scrolling while `locked` is true —
// for overlays that don't use antd's mask, which is the only case antd's
// own Drawer/Modal scroll locker handles.
//
// Mirrors that locker: each caller injects its own <style> tag rather than
// writing inline styles, so overlapping locks don't clobber each other's
// "previous value" — the page stays locked until the last one is removed.
// When a classic (non-overlay) scrollbar disappears, the body is narrowed by
// its width so content doesn't jump sideways.
export const usePageScrollLock = (locked: boolean): void => {
  useLayoutEffect(() => {
    if (!locked) return;

    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    const style = document.createElement('style');
    style.setAttribute('data-page-scroll-lock', '');
    style.textContent = `
html body {
  overflow-y: hidden;
  ${scrollbarWidth > 0 ? `width: calc(100% - ${scrollbarWidth}px);` : ''}
}`;
    document.head.appendChild(style);

    return () => {
      style.remove();
    };
  }, [locked]);
};
